var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociallink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    stroke: "#282D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5677 10.7786C12.5674 11.25 12.3793 11.7021 12.0446 12.0353C11.7099 12.3685 11.2561 12.5556 10.7829 12.5554C10.3098 12.5551 9.85621 12.3676 9.52184 12.0341C9.18748 11.7005 8.99976 11.2483 9 10.7768C9.00024 10.3053 9.1884 9.85325 9.52311 9.52004C9.85781 9.18683 10.3116 8.99976 10.7847 9C11.2578 9.00024 11.7115 9.18775 12.0458 9.5213C12.3802 9.85484 12.5679 10.3071 12.5677 10.7786ZM12.6212 13.8717H9.05352V25H12.6212V13.8717ZM18.2581 13.8717H14.7083V25H18.2225V19.1603C18.2225 15.9072 22.4769 15.605 22.4769 19.1603V25H26V17.9515C26 12.4674 19.703 12.6718 18.2225 15.365L18.2581 13.8717Z",
    fill: "#007CC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociallink);
export default __webpack_public_path__ + "static/media/social link.954815e4e956512eea4a6603431bff74.svg";
export { ForwardRef as ReactComponent };